// @flow strict
import React, { useEffect, useRef } from 'react';

type Props = {
  postTitle: string,
  postSlug: string
};

const Comments = (_props: Props) => {
  const commentsRef = useRef(null);

  useEffect(() => {
    const commentsElement = commentsRef.current;

    if (!commentsElement || commentsElement.hasChildNodes()) {
      return undefined;
    }

    const scriptElement = document.createElement('script');

    scriptElement.src = 'https://giscus.app/client.js';
    scriptElement.async = true;
    scriptElement.crossOrigin = 'anonymous';
    scriptElement.setAttribute('data-repo', 'kash1064/Kaeru-no-Himitsukichi-Public');
    scriptElement.setAttribute('data-repo-id', 'R_kgDOIVBBDA');
    scriptElement.setAttribute('data-category', 'Announcements');
    scriptElement.setAttribute('data-category-id', 'DIC_kwDOIVBBDM4C7HMf');
    scriptElement.setAttribute('data-mapping', 'title');
    scriptElement.setAttribute('data-strict', '0');
    scriptElement.setAttribute('data-reactions-enabled', '1');
    scriptElement.setAttribute('data-emit-metadata', '0');
    scriptElement.setAttribute('data-input-position', 'top');
    scriptElement.setAttribute('data-theme', 'light');
    scriptElement.setAttribute('data-lang', 'en');

    commentsElement.appendChild(scriptElement);

    return () => {
      commentsElement.innerHTML = '';
    };
  }, []);

  return <div ref={commentsRef} />;
};

export default Comments;
